import React from "react";
import { string, object, func } from "prop-types";
import { connect } from "react-redux";

import ProfileMenuItem from "../ProfileMenuItem";
import { verifyEmail } from "../../helper/api";
import { setLoading } from "../../helper/actions";

import "./profile-menu.m.css";

const ProfileMenu = ({ type = "profile", member, navigateToPage, setLoading }) => {
  const changePasswordClick = () => {
    setLoading(true);

    // User needs to validate the email account so send out an email to verify
    verifyEmail(member.email).then(navigateToPage("/profile/change-password")).finally(setLoading(false));
  };

  const editProfileClick = () => navigateToPage("/profile/edit");

  return (
    <div styleName="wrapper" className="profile-menu">
      <ProfileMenuItem label="My Account" type="outer" />
      <ProfileMenuItem label="My Profile" isActive={type === "profile"} href="/profile" />
      <div onClick={editProfileClick}>
        <ProfileMenuItem label="Edit Profile" isActive={type === "edit-profile"} />
      </div>
      {member && !member["verification-status"].includes("social-") && (
        <div onClick={changePasswordClick}>
          <ProfileMenuItem label="Change Password" isActive={type === "change-password"} />
        </div>
      )}
      <ProfileMenuItem label="Activities" type="outer" />
      <ProfileMenuItem label="My Comments" href="/my-comments" isActive={type === "comments"} />
      <ProfileMenuItem label="Saved Articles" isActive={type === "saved_news"} href="/saved" type="saved_news" />
    </div>
  );
};

ProfileMenu.propTypes = {
  type: string,
  member: object,
  navigateToPage: func,
  setLoading: func,
};

const mapStateToProps = (state) => ({
  member: state.member || null,
});

const mapDispatchToProps = (dispatch) => ({
  navigateToPage: (url) => global.app.navigateToPage(dispatch, url),
  setLoading: (isLoading) => dispatch(setLoading(isLoading)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfileMenu);
